module.exports = __webpack_public_path__ + "img/clientes_1.7f9ab364.png";